import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  canceled: boolean;
  hasDeliverables: boolean;
  className?: string;
}

const AttachmentDescription = ({ canceled, hasDeliverables, className }: ClassAttributes<HTMLElement> & Props) => {
  return !hasDeliverables && !canceled ? (
    <Typography className={className}>
      <FormattedMessage id={`show_creation_page.description.waiting_attachment`} />
    </Typography>
  ) : null;
};

export default AttachmentDescription;
